import { render, staticRenderFns } from "./SpacesEditorAutocomplete.vue?vue&type=template&id=bfc555fe"
import script from "./SpacesEditorAutocomplete.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorAutocomplete.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorAutocomplete.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports